import { flattenValues } from '@uniformdev/canvas';

export interface UniformLogo {
	src: string;
	alt: string;
	width?: number;
	heightPercentage?: number;
	href?: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const flattenLogoProps = (props: any) => {
	return {
		...props,
		logos: flattenValues(props.logos),
	};
};
